import { useEffect, useMemo, useState } from "react";
import lespetitschanteursdecharlesbourg from "../assets/artists/2025/lespetitschanteursdecharlesbourg.jpeg";
import mathieu_blain from "../assets/artists/2025/mathieu_blain.jpeg";
import philippebournival_yveslussier from "../assets/artists/2025/philippebournival_yveslussier.jpeg";
import home from "../assets/home.jpg";
import PageTitle from "../components/PageTitle";
import ConcertCard from "../components/home/ConcertCard";
import ProgramModal from "../components/modals/ProgramModal";

function Home() {
	const [activeConcert, setActiveConcert] = useState(null);

	const concerts = useMemo(
		() => [
			{
				date: new Date(2025, 5, 1),
				artist: "Les Petits Chanteurs de Charlesbourg",
				secondaryArtist: "et Dominique Gagnon",
				img: lespetitschanteursdecharlesbourg,
				program: [
					{
						title: "Veni Creator",
						author: "Pierre Dussault (1927-2021)",
					},
					{
						title: "Ave verum corpus, K 618",
						author: "Wolfgang Amadeus Mozart (1756-1791)",
					},
					{
						title: "La nuit, arr. : J. Noyon",
						author: "Jean-Philippe Rameau (1683-1764)",
					},
					{
						title: "Cantique de Jean Racine, opus 11",
						author: "Gabriel Fauré (1845-1924)",
					},
					{
						title: "Épilogue sur « Nun danket » and « Ballerma »",
						author: "Raymond Daveluy (1926-2016)",
					},
					{
						title: "Medley The Sound of Music, arr. : C. Warnick",
						author: "Musique : R. Rodgers — Paroles : O. Hammerstein II",
					},
					{
						title: "Medley Les misérables, arr. : E. Lojeski",
						author: "Musique : C.-M. Schönberg — Paroles : A. Boublil et J.-M. Natel",
					},
					{
						title: "Hymne à la beauté du monde, arr. : C. Béland",
						author: "Musique : C. St-Roch — Paroles : L. Plamondon",
					},
					{
						title: "Vangelis 1492, arr. : M. Aubert ",
						author: "Musique : Vangelis — Paroles : G. Protheroe",
					},
					{
						title: "Final, extrait des Trois esquisses pour pédalier solo",
						author: "Denis Bédard (né en 1950)",
					},
					{
						title: "Festive Toccata",
						author: "Denis Bédard (né en 1950)",
					},
				],
			},
			{
				date: new Date(2025, 5, 8),
				artist: "Mathieu Blain",
				secondaryArtist: "",
				img: mathieu_blain,
				program: [
					{
						title: "Prélude et fugue en do majeur, BWV 547",
						author: "Johann Sebastian Bach (1685-1750)",
					},
					{
						title: "Praeludium en ré majeur, BuxWV 139",
						author: "Dietrich Buxtehude (1637-1707)",
					},
					{
						title: "Choral « Allein Gott in der Höh sei Her », BWV 662",
						author: "Johann Sebastian Bach (1685-1750)",
					},
					{
						title: "Fantaisie et fugue en do mineur, H.75.5",
						author: "Carl Philipp Emanuel Bach (1714-1788)",
					},
					{
						title: "Fugue sur B.A.C.H., opus 56, no 6",
						author: "Robert Schumann (1810-1856)",
					},
					{
						title: "Prélude et fugue en mi bémol majeur, BWV 552",
						author: "Johann Sebastian Bach (1685-1750)",
					},
				],
			},
			{
				date: new Date(2025, 5, 15),
				artist: "Philippe Bournival, organiste",
				secondaryArtist: "et Yves Lussier, trompettiste",
				img: philippebournival_yveslussier,
				program: [
					{
						title: "Sonata Prima pour trompette et orgue, arr. : M. Rondeau",
						author: "Giovanni Buonaventura Viviani (1638-1693)",
					},
					{
						title: "Variations sur « Mein junges Leben hat ein End »",
						author: "Jan Pieterszoon Sweelinck (1562-1621)",
					},
					{
						title: "Gymnopédie No. 1 (orgue solo)",
						author: "Érik Satie (1866-1925)",
					},
					{
						title: "Suite anachronique pour trompette et orgue",
						author: "Philippe Bournival (né en 1975)",
					},
					{
						title: "Toccata et fugue en ré mineur, BWV 565",
						author: "Johann Sebastian Bach (1685-1750)",
					},
					{
						title: "Chorals Schübler, version pour trompette et orgue, BWV 645",
						author: "Johann Sebastian Bach (1685-1750)",
						items: ["Wachet auf, ruft uns die Stimme"],
					},
					{
						title: "Concerto en sib majeur pour trompette et orchestre",
						author: "Tomaso Albinoni (1671-1751)",
						items: ["Allegro", "Andante", "Allegro"],
					},
				],
			},
		],
		[]
	);

	useEffect(() => {
		const todayConcert = concerts.find(
			(concert) =>
				concert.date.getDate() === new Date().getDate() &&
				concert.date.getMonth() === new Date().getMonth()
		);

		setActiveConcert(todayConcert ?? null);
	}, [concerts]);

	return (
		<div className="text-center">
			<img
				src={home}
				alt="organ"
				className="object-contain w-full mt-8 shadow-xl rounded"
			/>

			<PageTitle title="23e édition | 2025" className="!mt-10 !mb-4" />
			<h2 className="text-xl mb-10 font-semibold">
				Tous nos concerts sont présentés gratuitement à{" "}
				<span className="font-bold italic">15 h</span> en l'église de
				Sainte-Marie !
			</h2>

			<div className="grid grid-cols-1 lg:grid-cols-3 gap-3 lg:gap-8 mb-10">
				{concerts.map((concert, index) => (
					<ConcertCard concert={concert} key={index} />
				))}
			</div>

			<ProgramModal
				concert={activeConcert}
				clear={() => setActiveConcert(null)}
			/>
		</div>
	);
}

export default Home;
